
var inputLess = {};
import genaration from '../../utils/classname';
export var inputClass = genaration(inputLess, 'input');